import { exQue, exMut } from "../../../utils/gql";
import {
  GET_TITULOS_PAGINATED,
  GET_TITULOS_PAGINATED_LIST,
  FIND_FEED_LIST, // Get all feeds [{..., noticias:[]}]
  GET_ALL_NEWS_TITLES, // Get all titles directly whitout pagination
} from "../../../apollo/queries";
import {
  CREATE_NEW_TITULAR,
  UPDATE_NEW_TITULAR,
  CHANGE_STATE_NEW_TITULAR,
  SAVE_FEED_LIST,
  UPDATE_FEED_LIST,
  DELETE_FEED_LIST,
} from "../../../apollo/mutations";
import { formatYYYMMDD } from "@/utils/time";

// Estados 1 para activo, 2 para deshabilitar, 3 para ocultar

export default {
  namespaced: true,
  state: {
    page: 1,
    paginacion: [],
    titulares: [],
    allTitles: [], // All titles without pagination
    newsFeeds: [], // All feeds
  },
  mutations: {
    setPagination(state, resp) {
      state.paginacion = resp;
    },
    setNewsByPagination(state, resp) {
      state.titulares = resp;
    },
    addNewsToList(state, titular) {
      state.titulares.unshift(titular);
    },
    UPDATE_NEWS_LIST(state, titular) {
      let found_index = state.titulares.findIndex(
        (news) => news.id_noticia == titular.id_noticia
      );
      if (found_index != -1)
        Object.assign(state.titulares[found_index], titular);
    },
    REMOVE_NEWS_FROM_LIST(state, id_noticia) {
      // Remover de la lista de titulares
      state.titulares = state.titulares.filter(
        (titular) => titular.id_noticia !== id_noticia
      );

      // Remover de la paginación
      state.paginacion.forEach((pagina) => {
        pagina.noticias = pagina.noticias.filter(
          (noticiaId) => noticiaId !== id_noticia
        );
      });
    },
    setAllNewsTitles(state, resp) {
      state.allTitles = resp;
    },
    setNewsFeeds(state, resp) {
      state.newsFeeds = resp;
    },
  },
  actions: {
    async getTitulosPaginated(
      { commit, dispatch },
      { limite } = { limite: 20 }
    ) {
      const resp = await exQue(
        GET_TITULOS_PAGINATED,
        { limite },
        false,
        "",
        "Error al obtener la paginación de titulares"
      );
      commit("setPagination", resp);
      if (resp.length > 0) {
        await dispatch("getTitulosPaginatedList", { page: 1 });
      }
    },
    async getTitulosPaginatedList({ commit, state }, { page = 1 }) {
      let ids = [];
      if (state.paginacion.length > 0) {
        const paginacion = state.paginacion.find((p) => p.pagina == page);
        if (paginacion) {
          ids = paginacion.noticias;
        }
      }
      if (state.paginacion.length === 0 || ids.length === 0) {
        commit("setNewsByPagination", []);
        return;
      }

      const resp = await exQue(
        GET_TITULOS_PAGINATED_LIST,
        { ids },
        false,
        "",
        "Error al obtener la lista de titulares"
      );
      commit("setNewsByPagination", resp);
    },
    async createNewTitular(
      { commit },
      { titulo_noticia, fecha_noticia, id_estado } = {
        titulo_noticia: "",
        fecha_noticia: formatYYYMMDD(new Date()),
        id_estado: 1,
      }
    ) {
      if (id_estado < 1 || id_estado > 3) {
        throw new Error("Estado inválido. Debe ser entre 1 y 3.");
      }
      const resp = await exMut(
        CREATE_NEW_TITULAR,
        { titulo_noticia, fecha_noticia, id_estado },
        "Titular creado exitosamente",
        "Error al crear el titular"
      );
      if (resp) {
        commit("addNewsToList", resp);
      }
    },
    async updateNewTitular(
      { commit },
      { id_noticia, titulo_noticia, fecha_noticia, id_estado }
    ) {
      if (id_estado < 1 || id_estado > 3) {
        throw new Error("Estado inválido. Debe ser entre 1 y 3.");
      }
      const resp = await exMut(
        UPDATE_NEW_TITULAR,
        {
          id_noticia,
          titulo_noticia,
          fecha_noticia,
          id_estado,
        },
        "Titular actualizado exitosamente",
        "Error al actualizar el titular"
      );
      if (resp) {
        commit("UPDATE_NEWS_LIST", resp);
      }
    },
    async changeStateNewTitular({ commit }, { id_noticia, id_estado }) {
      if (id_estado < 1 || id_estado > 3) {
        throw new Error("Estado inválido. Debe ser entre 1 y 3.");
      }
      const resp = await exMut(
        CHANGE_STATE_NEW_TITULAR,
        { id_noticia, id_estado },
        "Estado del titular actualizado exitosamente",
        "Error al cambiar el estado del titular"
      );
      if (resp) {
        commit("UPDATE_NEWS_LIST", resp);
      }
    },
    async deleteNewTitular({ commit }, { id_noticia }) {
      const resp = await exMut(
        CHANGE_STATE_NEW_TITULAR,
        { id_noticia, id_estado: 2 }, // Estado 2 = deshabilitado/eliminado
        "Titular eliminado exitosamente",
        "Error al eliminar el titular"
      );
      if (resp) {
        // En lugar de actualizar, removemos completamente de la lista
        commit("REMOVE_NEWS_FROM_LIST", id_noticia);
      }
    },
   async getAllTitles({ commit }) {
      await exQue(
        GET_ALL_NEWS_TITLES,
        {},
        false,
        "",
        "Error al obtener todos los titulares"
      ).then((resp) => {
        commit("setAllNewsTitles", resp);
      });
      return true;
    },
    async getAllFeeds({ commit }, { forceUpdate = false } = {}) {
      await exQue(
        FIND_FEED_LIST,
        {},
        forceUpdate,
        "",
        "Error al obtener las listas de noticias"
      ).then((resp) => {
        commit("setNewsFeeds", resp);
      });
      return true;
    },
    async createFeedList({ dispatch }, { nombre_lista }) {
      const resp = await exMut(
        SAVE_FEED_LIST,
        { nombre_lista },
        "Lista creada exitosamente",
        "Error al crear la lista"
      );
      if (resp) {
        // Refresh the feed lists after creating
        dispatch("getAllFeeds", { forceUpdate: true });
      }
      return resp;
    },
    async updateFeedList({ dispatch }, { id_lista, nombre_lista, noticias }) {
      const resp = await exMut(
        UPDATE_FEED_LIST,
        { id_lista, nombre_lista, noticias },
        "Lista actualizada exitosamente",
        "Error al actualizar la lista"
      );
      if (resp) {
        // Refresh the feed lists after updating
        dispatch("getAllFeeds" , { forceUpdate: true });
      }
      return resp;
    },
    async deleteFeedList({ dispatch }, { id_lista }) {
      const resp = await exMut(
        DELETE_FEED_LIST,
        { id_lista },
        "Lista eliminada exitosamente",
        "Error al eliminar la lista"
      );
      if (resp) {
        // Refresh the feed lists after deleting
        dispatch("getAllFeeds" , { forceUpdate: true });
      }
      return resp;
    },
  },
};
